import { MonitorIcon, MoonIcon, SunIcon } from "lucide-react";

import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

import { ThemeSchema, useTheme, type Theme } from "./ThemeProvider";

const themeOptions = [
  { value: "light", label: "Light", icon: SunIcon },
  { value: "dark", label: "Dark", icon: MoonIcon },
  { value: "system", label: "System", icon: MonitorIcon },
] as const satisfies readonly {
  value: Theme;
  label: string;
  icon: typeof SunIcon;
}[];

const themeIcons = {
  light: SunIcon,
  dark: MoonIcon,
  system: MonitorIcon,
} as const satisfies Record<Theme, typeof SunIcon>;

export function ThemeToggle() {
  const { theme, setTheme } = useTheme();
  const CurrentIcon = themeIcons[theme];

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        render={
          <Button aria-label="Toggle theme" className="size-10" size="icon" variant="ghost" />
        }
      >
        <CurrentIcon aria-hidden="true" data-icon="inline-start" />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-36">
        <DropdownMenuRadioGroup
          aria-label="Theme"
          value={theme}
          onValueChange={(value: unknown) => {
            const parsedTheme = ThemeSchema.safeParse(value);
            if (parsedTheme.success) setTheme(parsedTheme.data);
          }}
        >
          {themeOptions.map(({ icon: Icon, label, value }) => (
            <DropdownMenuRadioItem closeOnClick key={value} value={value}>
              <Icon aria-hidden="true" data-icon="inline-start" />
              {label}
            </DropdownMenuRadioItem>
          ))}
        </DropdownMenuRadioGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
